import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";
import { authStatus } from "../plugins/authStatus";
import constant from "../constant";
Vue.use(VueRouter);

const routes = [
  {
    path: "/welcome",
    name: "welcome",
    meta: {
      requiredAuth: false,
      layout: "default",
      title: "Bienvenue",
    },
    component: () => import("../views/Welcome.vue"),
  },
  {
    path: "/stocks",
    name: "stocks",
    meta: {
      requiredAuth: true,
      title: "Stocks",
      layout: "main",
    },
    component: () => import("../views/stocks/SellerItems.vue"),
  },
  {
    path: "/catalog",
    name: "catalog",
    meta: {
      requiredAuth: true,
      title: "Catalogue",
      layout: "main",
    },
    component: () => import("../views/catalog/Catalog.vue"),
  },

  {
    path: "/print",
    name: "print",
    meta: {
      requiredAuth: true,
      title: "Impression",
      layout: "main",
    },
    component: () => import("../views/printers/Printer.vue"),
  },

  {
    path: "/",
    name: "home",
    meta: {
      requiredAuth: true,
      title: "Tableau de bord",
      layout: "main",
    },
    component: Home,
  },

  {
    path: "/login",
    name: "login",
    meta: {
      layout: "default",
      title: "Connexion",
      requiredAuth: false,
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/login/:reference/password",
    name: "login-password",
    meta: {
      requiredAuth: false,
      title: "Code d'accès",
      layout: "default",
    },
    component: () => import("../views/LoginPassword.vue"),
  },

  {
    path: "/customers",
    name: "customers-list",
    meta: {
      requiredAuth: true,
      title: "Clients",
      layout: "main",
    },
    component: () => import("../views/customers/CustomersList.vue"),
  },
  {
    path: "/customers/create",
    name: "customers-create",
    meta: {
      requiredAuth: true,
      title: "Nouveau client",
      layout: "main",
    },
    component: () => import("../views/customers/CustomerCreate.vue"),
  },
  {
    path: "/customers/:reference/edit",
    name: "customers-edit",
    meta: {
      requiredAuth: true,
      title: "Modifier client",
      layout: "main",
    },
    component: () => import("../views/customers/CustomerEdit.vue"),
  },
  {
    path: "/customers/:reference",
    name: "customers-show",
    meta: {
      requiredAuth: true,
      title: "Détails client",
      layout: "main",
    },
    component: () => import("../views/customers/CustomerShow.vue"),
  },
  {
    path: "/orders",
    name: "orders-list",
    meta: {
      requiredAuth: true,
      title: "Commandes",
      layout: "main",
    },
    component: () => import("../views/orders/OrdersList.vue"),
  },
  {
    path: "/orders/create",
    name: "orders-create",
    meta: {
      requiredAuth: true,
      title: "Nouvelle commande",
      layout: "main",
    },
    component: () => import("../views/orders/OrderCreate.vue"),
  },
  {
    path: "/orders/:reference/edit",
    name: "orders-edit",
    meta: {
      requiredAuth: true,
      title: "Modifier commande",
      layout: "main",
    },
    component: () => import("../views/orders/OrderEdit.vue"),
  },
  {
    path: "/orders/:reference",
    name: "orders-show",
    meta: {
      requiredAuth: true,
      title: "Détails commande",
      layout: "main",
    },
    component: () => import("../views/orders/OrderShow.vue"),
  },
  {
    path: "/load-orders",
    name: "loadorders-list",
    meta: {
      requiredAuth: true,
      title: "Load Orders",
      layout: "main",
    },
    component: () => import("../views/loadOrders/LoadOrderList.vue"),
  },
  {
    path: "/load-orders/create",
    name: "loadorders-create",
    meta: {
      requiredAuth: true,
      title: "Create Load Order",
      layout: "main",
    },
    component: () => import("../views/loadOrders/LoadOrderCreate.vue"),
  },
  {
    path: "/load-orders/:reference/edit",
    name: "loadorders-edit",
    meta: {
      requiredAuth: true,
      title: "Edit Load Order",
      layout: "main",
    },
    component: () => import("../views/loadOrders/LoadOrderEdit.vue"),
  },
  {
    path: "/load-orders/:reference",
    name: "loadorders-show",
    meta: {
      requiredAuth: true,
      title: "Load Order Details",
      layout: "main",
    },
    component: () => import("../views/loadOrders/LoadOrderShow.vue"),
  },
  {
    path: "/payments",
    name: "payments-list",
    meta: {
      requiredAuth: true,
      title: "Paiements",
      layout: "main",
    },
    component: () => import("../views/payments/PaymentsList.vue"),
  },
  {
    path: "/payments/create",
    name: "payments-create",
    meta: {
      requiredAuth: true,
      title: "Nouveau paiement",
      layout: "main",
    },
    component: () => import("../views/payments/PaymentCreate.vue"),
  },
  {
    path: "/payments/:reference/edit",
    name: "payments-edit",
    meta: {
      requiredAuth: true,
      title: "Modifier paiement",
      layout: "main",
    },
    component: () => import("../views/payments/PaymentEdit.vue"),
  },
  {
    path: "/payments/:reference",
    name: "payments-show",
    meta: {
      requiredAuth: true,
      title: "Détails paiement",
      layout: "main",
    },
    component: () => import("../views/payments/PaymentShow.vue"),
  },
  {
    path: "/credits",
    name: "credits",
    meta: {
      requiredAuth: true,
      title: "Crédits clients",
      layout: "main",
    },
    component: () => import("@/views/credits/Credits.vue"),
  },
  {
    path: "/sales",
    name: "sales-list",
    meta: {
      requiredAuth: true,
      title: "Ventes",
      layout: "main",
    },
    component: () => import("../views/sales/SalesList.vue"),
  },
  {
    path: "/sales/create",
    name: "sales-create",
    meta: {
      requiredAuth: true,
      title: "Nouvelle vente",
      layout: "main",
    },
    component: () => import("../views/sales/QuickSale.vue"),
  },
  {
    path: "/sales/:reference/edit",
    name: "sales-edit",
    meta: {
      requiredAuth: true,
      title: "Modifier vente",
      layout: "main",
    },
    component: () => import("../views/sales/SaleEdit.vue"),
  },
  {
    path: "/sales/:reference",
    name: "sales-show",
    meta: {
      requiredAuth: true,
      title: "Détails vente",
      layout: "main",
    },
    component: () => import("../views/sales/SaleShow.vue"),
  },
  {
    path: "/seller-payments",
    name: "seller-payments-list",
    meta: {
      requiredAuth: true,
      title: "Paiements du vendeur",
      layout: "main",
    },
    component: () => import("../views/payments/SellerPaymentsList.vue"),
  },
  {
    path: "/items",
    name: "items-list",
    meta: {
      requiredAuth: true,
      title: "Articles",
      layout: "main",
    },
    component: () => import("../views/items/ItemsList.vue"),
  },
  {
    path: "/items/create",
    name: "items-create",
    meta: {
      requiredAuth: true,
      title: "Nouvel article",
      layout: "main",
    },
    component: () => import("../views/items/ItemCreate.vue"),
  },
  {
    path: "/items/:reference/edit",
    name: "items-edit",
    meta: {
      requiredAuth: true,
      title: "Modifier article",
      layout: "main",
    },
    component: () => import("../views/items/ItemEdit.vue"),
  },
  {
    path: "/items/:reference",
    name: "items-show",
    meta: {
      requiredAuth: true,
      title: "Détails article",
      layout: "main",
    },
    component: () => import("../views/items/ItemShow.vue"),
  },
  {
    path: "/items/image-update",
    name: "items-image-update",
    meta: {
      requiredAuth: true,
      title: "Mise à jour des images",
      layout: "main",
    },
    component: () => import("../views/items/ItemImageUpdate.vue"),
  },
  {
    path: "/caisse",
    name: "caisse",
    meta: {
      requiredAuth: true,
      title: "Caisse",
      layout: "main",
    },
    component: () => import("../views/caisse/Caisse.vue"),
  },
  {
    path: "/quick-sale",
    name: "quick-sale",
    meta: {
      requiredAuth: true,
      title: "Nouvelle Vente",
      layout: "main",
    },
    component: () => import("../views/sales/QuickSale.vue"),
  },
  {
    path: "/statistics",
    name: "statistics",
    meta: {
      requiredAuth: true,
      title: "Statistiques",
      layout: "main",
    },
    component: () => import("../views/sales/Statistics.vue"),
  },
];

const router = new VueRouter({
  mode: "history", // Use history mode for clean URLs
  base: process.env.BASE_URL,
  routes,
});

function isUserAuthenticated(authData) {
  const hasStoreUser =
    authData &&
    typeof authData === "object" &&
    authData !== null &&
    (authData.reference !== undefined || authData.id !== undefined);
  const token = localStorage.getItem(constant.authToken);
  const hasToken = !!token && token !== "null" && token !== "undefined";
  const authStatusCheck = authStatus.isAuthenticated;
  return hasStoreUser || authStatusCheck || hasToken;
}

function guard(to, from, next, authData) {
  // Refresh authStatus to ensure it's up to date (especially after page refresh)
  authStatus.refresh();

  const isAuthenticated = isUserAuthenticated(authData);

  // Handle root path redirect
  if (to.path === "/") {
    if (isAuthenticated) {
      return next(); // Allow access to home if authenticated
    } else {
      return next({ name: "welcome" }); // Redirect to welcome if not authenticated
    }
  }

  // Allow access if route explicitly doesn't require auth (e.g., welcome, login pages)
  const explicitlyNoAuth = to.meta && to.meta.requiredAuth === false;
  if (explicitlyNoAuth) {
    // If user is authenticated and trying to access welcome page, redirect to home
    if (isAuthenticated && to.name === "welcome") {
      return next({ name: "home" });
    }
    return next();
  }

  // Protected routes - require authentication
  if (isAuthenticated) {
    return next();
  }

  // Debug logging (remove in production if needed)
  console.warn("Router guard: Not authenticated", {
    authData,
    route: to.name,
  });

  // Not authenticated - redirect to login
  if (to.name !== "login") {
    return next({
      name: "login",
      query: { reason: "unauthenticated" },
    });
  }

  // If already on login page, allow it
  return next();
}

router.beforeEach((to, from, next) => {
  try {
    // Get fresh auth data from store (getters read from localStorage)
    let authData = store.getters["auth/user"];
    return guard(to, from, next, authData);
  } catch (error) {
    console.error("Router guard error:", error);
    // On error, check token directly
    const hasToken = !!localStorage.getItem(constant.authToken);
    if (hasToken) {
      return next();
    }
    // Redirect to welcome if error and not authenticated
    if (to.path === "/") {
      return next({ name: "welcome" });
    }
    return next({ name: "login", query: { reason: "error" } });
  }
});

export default router;
